import { HintTooltipStyled } from './HintTooltip.styles';
import { HintTooltipProps } from './types';

/**
 * Hint component.
 */
export const HintTooltip = ({
  title,
  children,
  open,
  onClose,
}: HintTooltipProps) => (
  <HintTooltipStyled
    arrow
    open={open}
    placement="bottom"
    title={title}
    type="click"
    onClose={onClose}
  >
    {children}
  </HintTooltipStyled>
);
